import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flex, flexAbsoluteCenter, flexJustifyCenter, mb, onDesktop, p, pr, resetWidth, w100} from "@pg-design/helpers-css";
import {CheckListIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

const pdfFile = "/static-rp/pdf/20_sposobow_na_poprawe_zdolnosci_kredytowych_v2.pdf";

export const CreditKnowledgeCheckList = () => {
    return (
        <div css={checkList}>
            <div css={iconWrapper}>
                <CheckListIcon width={120} height={153} />
            </div>
            <div css={checkListContent}>
                <Text css={checkListHeadline} as="h2" variant="headline_4">
                    Jakie są sposoby na poprawę zdolności kredytowej
                </Text>

                <Text css={text} variant="body_copy_1">
                    Nasza checklista ułatwi Ci budowanie lub podniesienie zdolności kredytowej.
                </Text>
                <div css={buttonWrapper}>
                    <Button
                        href={pdfFile}
                        css={buttonStyle}
                        variant="filled_primary"
                        dataTestId={CREDIT_PAGES_IDS.CREDITWORTHINESS_SUBPAGE.DOWNLOAD_CHECKLIST_BUTTON}
                    >
                        pobierz checklistę
                    </Button>
                </div>
            </div>
        </div>
    );
};
const checkListContent = css`
    padding: 1rem;
    ${flexJustifyCenter};
    flex-direction: column;
    ${onDesktop(p(2))};
`;
const checkListHeadline = (theme: Theme) => css`
    text-align: center;
    margin: 2rem 0;

    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
        margin: 0 0 1rem 0;
    }
`;

const buttonWrapper = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    ${w100};
    @media (min-width: ${theme.breakpoints.sm}) {
        ${flex()}
    }
`;
const buttonStyle = (theme: Theme) => css`
    ${w100};
    @media (min-width: ${theme.breakpoints.sm}) {
        ${resetWidth}
    }
`;

const checkList = (theme: Theme) => css`
    ${mb(2)};
    display: flex;
    flex-direction: column;
    align-items: center;
    ${p(5)};
    box-sizing: border-box;

    overflow: hidden;
    ${elevation(2)};
    ${borderRadius(2)}
    background-color: #b9e19b;

    &:hover {
        color: ${theme.colors.secondary};
        text-decoration: none;
        cursor: pointer;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(5, 0)};
        flex-direction: row;
    }
    @media (min-width: ${theme.breakpoints.md}) {
        ${p(5)};
    }
`;

const iconWrapper = (theme: Theme) => css`
    height: auto;
    width: 160px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: ${theme.breakpoints.md}) {
        height: calc(206px - 5rem);
        width: calc(206px - 4rem);
        ${pr(5)};
    }
    @media (min-width: 1200px) {
        height: calc(239px - 5rem);
        width: calc(349px - 4rem);
    }
`;
const text = (theme: Theme) => css`
    text-align: center;
    ${mb(6)};

    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
    }
`;
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flex, flexAbsoluteCenter, flexJustifyCenter, mb, onDesktop, p, pr, resetWidth, w100} from "@pg-design/helpers-css";
import {CheckListIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

const pdfFile = "/static-rp/pdf/20_sposobow_na_poprawe_zdolnosci_kredytowych_v2.pdf";

export const CreditKnowledgeCheckList = () => {
    return (
        <div css={checkList}>
            <div css={iconWrapper}>
                <CheckListIcon width={120} height={153} />
            </div>
            <div css={checkListContent}>
                <Text css={checkListHeadline} as="h2" variant="headline_4">
                    Jakie są sposoby na poprawę zdolności kredytowej
                </Text>

                <Text css={text} variant="body_copy_1">
                    Nasza checklista ułatwi Ci budowanie lub podniesienie zdolności kredytowej.
                </Text>
                <div css={buttonWrapper}>
                    <Button
                        href={pdfFile}
                        css={buttonStyle}
                        variant="filled_primary"
                        dataTestId={CREDIT_PAGES_IDS.CREDITWORTHINESS_SUBPAGE.DOWNLOAD_CHECKLIST_BUTTON}
                    >
                        pobierz checklistę
                    </Button>
                </div>
            </div>
        </div>
    );
};
const checkListContent = css`
    padding: 1rem;
    ${flexJustifyCenter};
    flex-direction: column;
    ${onDesktop(p(2))};
`;
const checkListHeadline = (theme: Theme) => css`
    text-align: center;
    margin: 2rem 0;

    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
        margin: 0 0 1rem 0;
    }
`;

const buttonWrapper = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    ${w100};
    @media (min-width: ${theme.breakpoints.sm}) {
        ${flex()}
    }
`;
const buttonStyle = (theme: Theme) => css`
    ${w100};
    @media (min-width: ${theme.breakpoints.sm}) {
        ${resetWidth}
    }
`;

const checkList = (theme: Theme) => css`
    ${mb(2)};
    display: flex;
    flex-direction: column;
    align-items: center;
    ${p(5)};
    box-sizing: border-box;

    overflow: hidden;
    ${elevation(2)};
    ${borderRadius(2)}
    background-color: #b9e19b;

    &:hover {
        color: ${theme.colors.secondary};
        text-decoration: none;
        cursor: pointer;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(5, 0)};
        flex-direction: row;
    }
    @media (min-width: ${theme.breakpoints.md}) {
        ${p(5)};
    }
`;

const iconWrapper = (theme: Theme) => css`
    height: auto;
    width: 160px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: ${theme.breakpoints.md}) {
        height: calc(206px - 5rem);
        width: calc(206px - 4rem);
        ${pr(5)};
    }
    @media (min-width: 1200px) {
        height: calc(239px - 5rem);
        width: calc(349px - 4rem);
    }
`;
const text = (theme: Theme) => css`
    text-align: center;
    ${mb(6)};

    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
    }
`;
